import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { AuthService } from '../../services/auth.service';
import { ProducerService } from '../../services/producer.service';

@Component({
  selector: 'app-header-toolbar',
  standalone: true,
  imports: [
    CommonModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatMenuModule
  ],
  templateUrl: './header-toolbar.component.html',
  styleUrls: ['./header-toolbar.component.scss']
})
export class HeaderToolbarComponent implements OnInit {
  @Input() showUserInfo: boolean = true;
  @Input() userDisplayName: string = '';
  @Input() showLogout: boolean = true;
  @Input() showNavigation: boolean = true;

  @Output() logout = new EventEmitter<void>();

  /** Agency (company) name from /producers/me — lets a producer see which company they're in. */
  companyName: string | null = null;

  constructor(
    private router: Router,
    private authService: AuthService,
    private producerService: ProducerService
  ) {}

  ngOnInit(): void {
    if (!this.showUserInfo) return;
    // Best-effort: super-admins may have no producer row in the active tenant (404) — just skip the chip.
    this.producerService.getCurrentProducer().subscribe({
      next: (p) => this.companyName = p.companyName ?? null,
      error: () => this.companyName = null
    });
  }

  onLogout(): void {
    this.logout.emit();
  }

  onNavigateToDashboards(): void {
    this.router.navigate(['/admin/dashboards']);
  }

  onNavigateToPrograms(): void {
    this.router.navigate(['/admin/programs']);
  }

  onNavigateToInsuranceCompanies(): void {
    this.router.navigate(['/super-admin/insurance-companies']);
  }

  onNavigateToProducers(): void {
    this.router.navigate(['/admin/producers']);
  }

  onNavigateToApiKey(): void {
    this.router.navigate(['/admin/api-key']);
  }

  onNavigateToQuotes(): void {
    this.router.navigate(['/quotes']);
  }

  // KAN-39 · Top-level console sections. Quotes = OFFERS (view=quotes),
  // Accounts = ACTIVE BOOK (view=accounts), Customers = per-person directory.
  onNavigateToAccounts(): void {
    this.router.navigate(['/accounts']);
  }

  onNavigateToCustomers(): void {
    this.router.navigate(['/customers']);
  }

  hasAdminRole(): boolean {
    return this.authService.hasAdminRole();
  }

  hasSuperAdminRole(): boolean {
    return this.authService.hasSuperAdminRole();
  }
}
